var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative py-10 px-20 h-full"},[_c('img',{staticClass:"max-h-30",attrs:{"src":_vm.state.quote.customer.logo.url}}),_c('Menu',{staticClass:"mt-24"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }